define( function() {
	return ( /\?/ );
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/ajax/var/rquery.js
// module id = 324
// module chunks = 1